<template src="./TRT_Home.HTML"></template>
<style src="./Data_Tools.css" scoped></style>
<style>
#ptv-map .ol-attribution {
  /* Inline, just left of the Help pill (~3em wide at right: .5em). */
  bottom: .5em !important;
  right: 4.5em !important;
}

.fly-clone {
  transition: transform 1.5s ease;
  background: #007bff;
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  pointer-events: none;
}

.simulated-pointer.click-animation {
  transform: scale(0.9); /* quick “press down” */
  transition: transform 0.1s ease-in-out;
}
</style>
<script>
const TRAIL_YEAR_COLORS = {
  2014: '#708090',
  2015: '#000000',
  2016: '#6F452B',
  2017: '#E9BD02',
  2018: '#0F6001',
  2019: '#6F067B',
  2020: '#BA831F',
  2021: '#00B1AE',
  2022: '#E5571D',
  2023: '#B91E02',
  2024: '#e15dd3',
  2025: '#45db24',
  2026: '#168be1',
}

// PTV imports
import DT_ChangePassword from './DT_ChangePassword.vue'
import DT_ReleaseNotes from './DT_ReleaseNotes.vue'
import DT_Measurement from './DT_Measurement.vue'
import MMP_MapSettings from '../shared/MMP_MapSettings.vue'
import DT_ReleaseHistory from './DT_ReleaseHistory.vue'
import DT_LayerList from './DT_LayerList.vue'
import DT_ReleaseModal from './DT_ReleaseModal.vue'
import DT_Widgets from './DT_Widgets.vue'
import TRT_Dashboard from './TRT_Dashboard.vue'
import DT_NavBar from './DT_NavBar.vue'
import DT_LatLong from './DT_LatLong.vue'
import DT_ZoomLevel from './DT_ZoomLevel.vue'
import DT_ZoomWidget from './DT_ZoomWidget.vue'
import DT_Tutorial from './DT_Tutorial.vue'
import DT_Tools from './DT_Tools.vue'
import DT_Attributes from './DT_Attributes.vue'
import MMP_LoadingScreen from '../shared/MMP_LoadingScreen.vue'
import TRT_TrailsCart from './TRT_TrailsCart.vue'
import Moveable from 'vue-moveable'
// Package Imports
import axios from 'axios'
// OpenLayers imports
import 'ol/ol.css'
import Attribution from 'ol/control/Attribution'
import Map from 'ol/Map'
import View from 'ol/View'
import Point from 'ol/geom/Point'
import { GeoJSON } from 'ol/format'
import { OSM, XYZ } from 'ol/source'
import { Tile as TileLayer } from 'ol/layer'
import { unByKey } from 'ol/Observable'
import { Vector as VectorSource } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import { Style, Stroke, Fill, Text, Circle, RegularShape } from 'ol/style';
import Select from 'ol/interaction/Select';
import { click, never } from 'ol/events/condition';
import Feature from 'ol/Feature'
import { addDays, createLayers } from '../../../utils/utils.js'
import {
  get as projGet,
  fromLonLat,
  toLonLat,
  transform,
  transformExtent,
  get
} from 'ol/proj'

import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'TRT_Home',
  components: {
    DT_ChangePassword,
    DT_ReleaseNotes,
    MMP_MapSettings,
    DT_ReleaseHistory,
    DT_LayerList,
    DT_ReleaseModal,
    DT_Widgets,
    TRT_Dashboard,
    DT_NavBar,
    DT_LatLong,
    DT_ZoomLevel,
    DT_Measurement,
    DT_ZoomWidget,
    DT_Tutorial,
    DT_Tools,
    DT_Attributes,
    Moveable,
    MMP_LoadingScreen,
    TRT_TrailsCart
  },
  data() {
    return {
      app: 'Home',
      dmpWhiteImg: require('../../../assets/dmpWhite.png'),
      user: null,
      versionReleaseInfo: null,
      isUshrUser: false,
      mapsMode: true,
      map: null,
      currentBaseMap: null,
      selectedExtent: null,
      drtLayersButtonsCtrl: [],
      ptv_layersObj: {},
      spinnerManager: [],
      layerResponse: null,
      ptv_layers: [],
      lidarIsLoading: false,
      olMapMoveStartKey: null,
      olMapMoveEndKey: null,
      zoomStarted: null,
      zoomControlArr: null,
      shortTermLayerMemory: [],
      zoomEnded: null,
      zoomLevelCap: 13,
      zoomLevel: null,
      showLidarPanel: false,
      olImageLoadStartKey: null,
      olImageLoadEndKey: null,
      olImageLoadErrorKey: null,
      olTileLoadStartKey: null,
      olTileLoadEndKey: null,
      olTileLoadErrorKey: null,
      olSelectkey: null,
      legendImgSrc: null,
      layerLegendName: null,
      layerLegend: false,
      layerLegendMaxHeight: null,
      layerLegendMinimized: false,
      selectedRelease: null,
      extentResponse: [],
      showAttributes: false,
      vectorLayer: null,
      attributesName: null,
      showMeasuringTool: false,
      showSnippingTool: false,
      polygonVectorLayers: [],
      clickedCoords: null ,// Right click coordinates on map,
      // showAISearch: false,
      isAdmin: false,
      measurement: null,
      polygonsSelected: [],
      polygonSelectEvent: null,
      tutorialTrigger: false,
      ptvMapFlag: false,
      lidarFlag: false,
      project_id: null,
      observer: null,
      distinct_lidar: [],
      extentName: null,
      features: [],
      feature_index: null,
      queryWindowResponse: null,
      fullSite: null,
      moveable: {
        draggable: true,
        throttleDrag: 0,
        throttleDragRotate: 0
      },
      lidarMinZoomAchieved: false,
      attributesPanelMinimized: false,
      trailsLoading: false,
      distinct_trails: [],
      showTrailsPanel: false,
      selectedTrails: [],
      driverObj: null,
      showLoadingScreen: true,
      filteredYears: null,
      lidarTrailsActive: false,
      cart: [],
      disableTrailGroups: false,
      kmzLoadingTotal: 0,
      kmzLoadingDone: 0,
      trtAdminAccounts: [],
      menuCollapsed: false
    }
  },
  async mounted() {
    this.showLoadingScreen = true
    await this.initPTV()
    if (!sessionStorage.pid && !typeof sessionStorage.pid == "string") {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
      this.$emit('clearCurrentPositionsInterval')
      this.$router.push({name: 'Login'})
    }

    if (this.$route.query.openMap) {
      await this.$nextTick(() => {
        this.loadProject('Lidar')
      })
    } else {
      this.showLoadingScreen = false
    }

    this.getTRTAdminAccounts()
  },
  created() {
    window.addEventListener('beforeunload', this.handlerClose)
  },
  watch: {
    '$route.query.dashboard'(val) {
      if (val === '1') {
        this.mapsMode = false
        this.reset()
      }
    }
  },
  methods: {
    getReleaseVersion() {
      if (sessionStorage.token) {
        axios
          .get(process.env.API_LOCATION + '/api/release_notes/checkReleaseVersion', {
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: { id: this.user.org }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('checkReleaseVersion API Call Error: ' + content.errors)
            } else {
              this.versionReleaseInfo = content[0]
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },
    async reset(done) {
      if(this.showLidarPanel) {
        this.toggleLidarPanel();
      }
      if (this.showTrailsPanel) {
        this.toggleTrailsPanel();
      }
      this.clearCart();
      this.removePolygons();
      await this.observer?.disconnect();
      await this.destroyMap();
      this.persistingLayerFilters = []
      this.showLidarPanel = false;
      this.ptvMapFlag = false;
      this.lidarFlag = false;
      this.showLidarPanel = false;
      this.selectedRelease = null;
      this.selectedTrails = [];
      this.cart = [];
      this.disableTrailGroups = false;

      if (done) {
        done();
      }
    },
    toggleMeasuringTool() {
      this.showMeasuringTool = !this.showMeasuringTool
    },
    toggleSnippingTool() {
      this.showSnippingTool = !this.showSnippingTool
    },
    async getLayers(release) {
      this.drtLayersButtonsCtrl.forEach(layer => {
        this.unloadLayers(layer.name)
      })
      this.drtLayersButtonsCtrl = []
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/layer/release', {
            method: 'GET',
            headers: {
              'x-auth-token': sessionStorage.token
            },
            params: {
              extent: release.extent_description,
              release_id: release.id
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('release API Call Error: ' + content.errors)
            } else {
              const layerLinks = []
              this.layerResponse = content
              content.filter(e => e.visibility != false).forEach(link => {
                let linkObj = link.link_object
                let linkObjLayerGroup = linkObj.info.layer_group
                // Replaces all underscores with spaces
                let output = linkObj.name.replace(/_/g, ' ')
                let objToPush = {
                  name: linkObj.name,
                  zoomControl: linkObj.zoomControl,
                  display_name: output,
                  layer_group: linkObjLayerGroup,
                  minZoom:
                    linkObj.minZoom == undefined ? null : linkObj.minZoom,
                  layer_definition:
                    linkObj.layerDefinition == undefined
                      ? null
                      : linkObj.layerDefinition,
                  fullMap: linkObj.fullMap
                }
                linkObj['display_name'] = output
                layerLinks.push(linkObj)
                this.drtLayersButtonsCtrl.push(objToPush)
              })

              this.ptv_layers = layerLinks
              this.ptv_layersObj = createLayers(this.ptv_layers, this.map)

              this.drtLayersButtonsCtrl.forEach(layerobj => {
                this.unloadLayers(layerobj.name)
              })
              new unByKey(this.olMapMoveStartKey)
              new unByKey(this.olMapMoveEndKey)
              this.setListeners()
            }
          })
      } else {
        console.log('No User Token')
      }
    },
    setListeners() {
      this.olMapMoveStartKey = this.map.on('movestart', evt => {
        this.lidarIsLoading = true
        this.zoomStarted = this.map.getView().getZoom()
      })
      this.olMapMoveEndKey = this.map.on('moveend', evt => {
        this.zoomControlArr = this.zoomControlLayers(this.ptv_layersObj)
        this.zoomEnded = this.map.getView().getZoom()

        // Zoom controlled layer handling
        for (let i in this.zoomControlArr) {
          let zoomLayer = this.zoomControlArr[i]
          let layerIndex = this.shortTermLayerMemory.indexOf(
            zoomLayer.ButtonName
          )
          let layerRemembered = layerIndex != -1
          let item = document.getElementById(zoomLayer.ButtonName)
          let showLayer =
            zoomLayer.minZoom == null
              ? this.zoomEnded >= this.zoomLevelCap
              : this.zoomEnded >= zoomLayer.minZoom
          if (item) {
            // If user is zoomed in enough...
            if (showLayer) {
              /* If the layer exists in short term memory,
              remove it since the layer is being enabled. */
              if (layerRemembered) {
                this.toggleLayerVisibility(zoomLayer.ButtonName) // TODO: need this fn eventually
                this.shortTermLayerMemory.splice(layerIndex, 1)
              }
            } else {
              this.map.getLayers().forEach(layer => {
                if (layer.get('name') == zoomLayer.ButtonName) {
                  /* If turning the layer off, add it to short term layer
                  memory to be enabled again later. */
                  if (!layerRemembered) {
                    this.shortTermLayerMemory.push(zoomLayer.ButtonName)
                  }
                }
              })
              this.unloadLayers(zoomLayer.ButtonName)
            }
          }
        }

        // Lidar zoom warning handling
        if (this.showLidarPanel) {
          this.lidarDownload(this)
        }
        if (this.showTrailsPanel) {
          this.trailDownload(this)
        }
        this.setLidarMinZoomAchieved(this.zoomEnded >= 17)
      })
    },
    // This function generates the button list to be disabled even on zoom in and zoom out
    zoomControlLayers(layers) {
      let zoomAr = []
      for (let key in layers) {
        if (layers[key].zoomControl) {
          zoomAr.push({
            layer: layers[key].layer,
            ButtonName: key,
            minZoom:
              layers[key].minZoom == undefined ? null : layers[key].minZoom
          })
        }
      }
      return zoomAr
    },
    async datasetSelected(release) {
      this.selectedRelease = release
      if (this.selectedRelease.extent_description != this.selectedExtent) {
        let extent = this.extentResponse.filter(e => e.extent_description == this.selectedRelease.extent_description)[0]
        this.changeExtent(extent)
      }
      this.selectedExtent = release.extent_description
      await this.getLayers(release)
      this.getMapExtent()

      // this.tutorialTrigger = true
      if (!this.user.tutorial_acknw["TRT"]) {
        this.startTutorial()
      }

      this.$bvModal.hide('ptvReleaseModal')
    },
    destroyMap() {
      if (this.map) {
        this.map.setTarget(null); // Disconnects map from DOM
        this.map.getLayers().clear();
        this.map = null;
        this.polygonsSelected = [];
        this.polygonVectorLayers = [];
        this.drtLayersButtonsCtrl = [];
      }

      this.closeLegend()

      // this.mapsMode = false;
      this.selectedExtent = 'North America'
    },
    async loadProject(project) {
      this.selectedRelease = null
      switch(project) {
        case 'Maps':
          this.initMaps();
          this.project_id = 35;
          this.lidarFlag = false;
          this.ptvMapFlag = true;
          this.$bvModal.show('ptvReleaseModal')
          break;
        case 'Lidar':
          await this.initMaps();
          if (!this.menuCollapsed) {
            this.toggleCollapse()
          }
          this.project_id = 37;
          this.ptvMapFlag = false;
          this.lidarFlag = true;
          this.$bvModal.show('ptvReleaseModal')
          this.toggleTrailsPanel();
          this.selectedTrailsLayer = new VectorLayer({
            source: new VectorSource(),
            style: feature => {
              const pcId = feature.get('pc_id') || ''
              const match = pcId.match(/\d{6}/)
              const featureYear = match ? parseInt(match[0].substring(0, 4)) : null

              // Hide if year is filtered out
              if (this.filteredYears !== null) {
                if (!featureYear || !this.filteredYears.includes(featureYear)) return null
              }

              const color = TRAIL_YEAR_COLORS[featureYear] || '#ff0000'
              const index = feature.get('selectedIndex')
              return new Style({
                stroke: new Stroke({ color, width: 4 }),
                text: index != null
                  ? new Text({
                      text: String(index),
                      font: 'bold 14px Arial',
                      fill: new Fill({ color: '#ffffff' }),
                      stroke: new Stroke({ color, width: 3 }),
                      placement: 'line',
                      overflow: true
                    })
                  : null
              })
            }
          });
          this.map.addLayer(this.selectedTrailsLayer)
          this.selectedTrailsLayer.setZIndex(999999);
          break;
        case 'Dashboard':
          this.mapsMode = false;
          this.ptvMapFlag = false;
          this.lidarFlag = false;
          if (this.showTrailsPanel) {
            this.toggleTrailsPanel();

          }
          this.clearCart()
          this.removePolygons()
      }
    },
    toggleCollapse() {
      this.menuCollapsed = !this.menuCollapsed
    },
    initMaps() {
      this.mapsMode = true
      this.$nextTick(() => {
        this.map = new Map({
          controls: [new Attribution({ collapsible: true })],
          target: 'ptv-map',
          pixelRatio: 1,
          layers: [
              new TileLayer({
                source: new OSM(),
                name: 'OSM base layer',
                zIndex: 2
              })
          ],
          view: new View({
            center: [0, 0],
            zoom: 5, // TRT Default Zoom Level = 5
            maxZoom: 21
          }),
        });

        this.currentBaseMap = 'OpenStreetMap'

        this.map.getViewport().addEventListener('contextmenu', evt => {
          evt.preventDefault()
          let coords = toLonLat(this.map.getEventCoordinate(evt, 'EPSG:4326'))
          this.clickedCoords = coords // this will trigger copy function in PTV_LatLong
        })

        const mapDOMElement = document.getElementById('ptv-map')
        this.observer = new ResizeObserver(() => {
          this.map?.updateSize();
        })

        this.observer.observe(mapDOMElement)

        this.transformExtent(this.extentResponse)

        this.zoomEnded = this.map.getView().getZoom()

        setTimeout(() => {
          this.showLoadingScreen = false;
        }, 1000)
      })
    },
    async initPTV() {
      await this.generateTutorial();
      await this.getUser();
      await this.getExtent();
    },
    async getUser() {
      if (sessionStorage.token) {
        await axios
          .get(process.env.API_LOCATION + '/api/auth', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            let info = response.data
            let auth = info.authorization
            this.user = {
              email: info.email,
              id: info.id,
              inactive: info.inactive,
              name: info.name,
              org: info.org,
              role: auth.permissions,
              test: auth.testAccount == 'True',
              group: auth.group,
              extent: info.extent_id != null ? info.extent_id : null,
              isAdmin: this.globalIsUserAllowed('Trail_Review_Tool_Admin_Dashboard'),
              tutorial_acknw: info.tutorial_acknw ? info.tutorial_acknw : {}
            }
            this.isUshrUser = info.org == 1
            // REFACTOR SUGGESTION -- WEBGIS-2548 -- self.user.errors is never going to be true here. Self.user is set above
            if (this.user.errors) {
              this.$router.push({ name: 'Login' })
            }
            if (this.user != null) {
              this.getReleaseVersion()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        this.$router.push({ name: 'Login' })
      }

      return Promise.resolve(true)
    },
    async getTRTAdminAccounts() {
      if (sessionStorage.token) {
        await axios.get(
            `${process.env.API_LOCATION}/api/trailReviewTool/getAdmin`,
            { headers: { 'x-auth-token': sessionStorage.token } }
        )
        .then(response => {
          this.trtAdminAccounts = response.data.map(u => u.id)
        })
        .catch(function (error) {
            console.log(error)
        })
      }
    },
    async sendAdminNotifications(obj) {
      const d = new Date();

      const timestamp = d.toLocaleDateString(navigator.language, { month:'2-digit', day: '2-digit', year: 'numeric'}) 
                    + ", " + d.toLocaleTimeString(navigator.language, {hour: '2-digit', minute:'2-digit'})
      
      let msg = `A new LiDAR sample request has been submitted by ${this.user.name}.
                \n\nRequest Details: 
                  **REGION: ${obj.region}
                  **Requested Delivery Date: ${obj.deliveryDate}
                  **Requested Delivery Type: ${obj.deliveryType}
                  **Created Date: ${timestamp}

                \n\nThe request is now available for review.`

      this.trtAdminAccounts.forEach(user_id => {
        this.pushNotification({msg: msg, user_id: user_id})
      })
    },
    pushNotification(obj) {
        if (sessionStorage.token) {
          axios.post(
            `${process.env.API_LOCATION}/api/trailReviewTool/sendNotification`,
            {
              msg: obj.msg,
              to_user_id: obj.user_id
            },
            { headers: { 'x-auth-token': sessionStorage.token } }
          )
          .catch(function (error) {
            console.log(error)
          })
        }
    },
    handlerClose() {
      sessionStorage.removeItem('token')
      sessionStorage.removeItem('pid')
    },
    unloadLayers(layerNameToToggle) {
      let layer
      if (this.ptv_layersObj[layerNameToToggle] != null) {
        layer = this.ptv_layersObj[layerNameToToggle].layer
      }

      if (layer) {
        // Unloading layer function
        this.map.removeLayer(layer)
        // Removes layer that has been turned off from spinnerManager
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      }
    },
    toggleLayerVisibility(layerNameToToggle) {
      if (layerNameToToggle == 'OSM') {
        this.map.getLayers().forEach(layer => {
          if (layer != undefined && layer.get('name') != undefined) {
            if (!layer.get('name').includes('OSM')) {
              this.toggleBaseLayer('Azure')
            }
          }
        })
      } else {
        if (this.ptv_layersObj.hasOwnProperty(layerNameToToggle)) {
          const layer = this.ptv_layersObj[layerNameToToggle].layer

          // If the layer doesn't exist on the map, add it to the map
          if (!this.checkLayer(layer)) {
            this.toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle)
            this.map.addLayer(layer)
            this.getLegend(layerNameToToggle)
            if (this.ptv_layersObj[layerNameToToggle]?.layer?.getSource?.()?.getParams?.()?.LAYERS?.includes('lidar_trails')) this.lidarTrailsActive = true
          } else {
            this.toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle)
            if (this.ptv_layersObj[layerNameToToggle]?.layer?.getSource?.()?.getParams?.()?.LAYERS?.includes('lidar_trails')) this.lidarTrailsActive = false
          }
        }
      }
    },
    toggleBaseLayer(newBaseLayer) {
      this.resetBaseLayer()
      this.currentBaseMap = newBaseLayer // REFACTOR SUGGESTION -- WEBGIS-2548 -- I feel like this could break something if newBaseLayer doesn't match any of the below options
      switch (newBaseLayer) {
        case 'OpenStreetMap':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM(),
              name: 'OSM base layer',
              zIndex: 2
            })
          )
          break
        case 'Azure':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new XYZ({
                url: `https://atlas.microsoft.com/map/tile?api-version=2.1&tilesetId=microsoft.imagery&zoom={z}&x={x}&y={y}&subscription-key=${process.env.AZURE_MAPS_KEY}`,
                attributions: '© Microsoft Azure Maps',
                // Azure 'microsoft.imagery' tiles only exist up to zoom 19.
                // Cap the tile grid so OpenLayers over-zooms (upscales) the z19
                // tiles past 19 instead of requesting missing tiles (black map).
                maxZoom: 19
              }),
              name: 'Azure base layer',
              zIndex: 2
            })
          );
          break;
        case 'Black':
          this.map.getLayers().insertAt(
            0,
            new TileLayer({
              source: new OSM(),
              name: 'Black base layer',
              zIndex: 2,
              opacity: 0
            })
          )
          break
      }
    },
    resetBaseLayer() {
      this.map.getLayers().forEach(layer => {
        if (layer != undefined && layer.get('name') != undefined) {
          if (layer.get('name').includes('base')) {
            if (this.checkLayer(layer)) {
              this.map.removeLayer(layer)
            }
          }
        }
      })
    },
    checkLayer(layer) {
      // Checks if layer exists on the map
      let exists = false
      let mapLayersArr = this.map.getLayers().getArray()

      switch (typeof layer) {
        case 'object':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists = mapLayersArr[i] == layer
            if (exists) {
              break
            }
          }
          break
        case 'string':
          for (let i in mapLayersArr) {
            // If layer exists, return true
            exists =
              mapLayersArr[i].values_.hasOwnProperty('name') &&
              mapLayersArr[i].values_.name == layer
            if (exists) {
              break
            }
          }
          break
      }

      return exists
    },
    toggleLayerVisibilityAddKeyHelper(layer, layerNameToToggle) {
      /* ImageWMS spinner addition and deletion */
      // Add layer to spinnerManager when image loads/refreshes
      this.olImageLoadStartKey = layer
        .getSource()
        .on('imageloadstart', event => {
          this.spinnerManager.push(layerNameToToggle)
        })
      // Remove layer from spinnerManager when image finishes loading
      this.olImageLoadEndKey = layer.getSource().on('imageloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if image encounters a loading error
      // NOTE - Image Load Error has spelling mistake -- should probably check that the correct event (with spelling mistake) is called
      this.olImageLoadErrorKey = layer
        .getSource()
        .on('imageloadeerror', event => {
          let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
          if (layerIndex != -1) {
            this.spinnerManager.splice(layerIndex, 1)
          }
        })

      /* TileWMS spinner addition and deletion */
      // Add layer to spinnerManager when tile loads/refreshes
      this.olTileLoadStartKey = layer.getSource().on('tileloadstart', event => {
        this.spinnerManager.push(layerNameToToggle)
      })
      // Remove layer from spinnerManager when tile finishes loading
      this.olTileLoadEndKey = layer.getSource().on('tileloadend', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
      // Remove layer from spinnerManager if tile encounters a loading error
      this.olTileLoadErrorKey = layer.getSource().on('tileloaderror', event => {
        let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
        if (layerIndex != -1) {
          this.spinnerManager.splice(layerIndex, 1)
        }
      })
    },
    toggleLayerVisibilityRemoveKeyHelper(layer, layerNameToToggle) {
      // Removes layer listeners
      new unByKey(this.olImageLoadStartKey)
      new unByKey(this.olImageLoadEndKey)
      new unByKey(this.olImageLoadErrorKey)
      new unByKey(this.olTileLoadStartKey)
      new unByKey(this.olTileLoadEndKey)
      new unByKey(this.olTileLoadErrorKey)
      // Removes layer that has been turned off from spinnerManager
      let layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      while (layerIndex != -1) {
        this.spinnerManager.splice(layerIndex, 1)
        layerIndex = this.spinnerManager.indexOf(layerNameToToggle)
      }
      this.map.removeLayer(layer)
    },
    // This function fetches the legends for each layer for DRT on button click
    getLegend(layerName) {
      this.map.getLayers().forEach(layer => {
        if (layer.get('name') == layerName) {
          // layerUrl will be 'undefined' if getLegendUrl fails to generate a URL.
          let layerUrl = layer
            .getSource()
            .getLegendUrl(this.map.getView().getResolution())
          if (layerUrl) {
            this.legendImgSrc = `${layerUrl}&LEGEND_OPTIONS=fontAntiAliasing:true;fontSize:17;bgColor:0xffffff;fontColor:0x003a3a3a;forceLabels:on;` + '&authkey=' + sessionStorage.token
            this.layerLegendName = layerName
            // After setting legend URL, show legend component
            this.layerLegend = true
          } else {
            console.log('FAILED TO FIND URL FOR LEGEND.')
          }
        }
      })
    },
    maxOrMinLegend(bool) {
      this.layerLegendMinimized = bool
    },
    closeLegend() {
      this.layerLegend = false
    },
    async getExtent() {
      if (sessionStorage.token) {
        /* This API call is made to get the response for extent at
        initialization which we can sort further as required.
        This will reduce the additional trip to the backend. */
        await axios
          .get(process.env.API_LOCATION + '/api/users/getAllExtents', {
            headers: {
              'x-auth-token': sessionStorage.token
            }
          })
          .then(response => {
            const content = response.data
            if (content.errors) {
              console.log('getAllExtents API Call Error: ' + content.errors)
            } else {
              this.extentResponse = []
              content.forEach(element => {
                this.extentResponse.push(element)
              })
              // This function assigns extent to the map for North America
              // this.transformExtent(this.extentResponse)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async transformExtent(extArray) {
      let extentValues = []
      let extentCenter = []
      let arr

      // Assign customized extent
      switch (this.selectedExtent) {
        // REFACTOR -- WEBGIS-2548 -- Commented out unused switch case options
        // REFACTOR SUGGESTION -- WEBGIS-2548 -- Should there be an option for Middle East??
        // case '"North America"':
        // case '"Continental United States"':
        default:
          arr = extArray.filter(e => e.extent_description == 'North America')
          break
        case '"Europe"':
          arr = extArray.filter(e => e.extent_description == 'Europe')
          break
        case '"Middle East"':
          arr = extArray.filter(e => e.extent_description == 'Middle East')
          break
        case '"Japan"':
          arr = extArray.filter(e => e.extent_description == 'Japan')
          break
      }

      // Need to convert the string into array of numbers for passing to the transformExtent function
      arr[0].extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      arr[0].extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })

      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view;
      view = new View({
        extent: coord,
        center: center,
        constrainOnlyCenter: true,
        zoom: 5,
        minZoom: 3,
        maxZoom: 21,
        multiWorld: true
      })

      this.map.setView(view)
    },
    changeExtent(selectedExtent) {
      this.removePolygons();
      let extentValues = []
      let extentCenter = []
      /* Need to convert the string into array of numbers for passing
      to the transformExtent function. */
      selectedExtent.extent.split(',').forEach(element => {
        extentValues.push(element)
      })
      selectedExtent.extent_center.split(',').forEach(element => {
        extentCenter.push(element)
      })
      let coord = new transformExtent(
        extentValues,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let center = new transform(
        extentCenter,
        new projGet('EPSG:4326'),
        new projGet('EPSG:3857')
      )

      let view = new View({
        extent: coord,
        center: center,
        constrainOnlyCenter: true,
        zoom: 5, 
        minZoom: 3,
        maxZoom: 21,
        multiWorld: true
      })
      
      this.map.setView(view)
    },
    getShowAttributes(data) {
      this.showAttributes = data
      if (!this.showAttributes) {
        // Removes circle that appears on map when user inputs coordinates to zoom to
        this.map.removeLayer(this.vectorLayer)
        this.vectorLayer = null
      }
    },
    // Loads attributes for all layer
    loadAttributes(attr) {
      let obj = attr.name
      let layer_group = attr.layer_group
      let layerResponse = attr.response
      let layerobj = null
      if (this.ptv_layersObj.hasOwnProperty(obj)) {
        layerobj = layerResponse.filter(c => {
          return (
            c.link_object.info != undefined &&
            c.link_object.info.layer_group == layer_group
          )
        })
      }
      if (layerobj != null) {
        let param = layerobj.filter(c => c.link_object.name == obj)
        if (param.length != 0) {
          /* unByKey function will disable all single-click events
          for layers other than the selected layer */
          new unByKey(this.olSelectkey)
          // This check provides dynamic names to attributes window
          this.attributesName = param[0].layer_name.replace(/_/g, ' ')
          this.olSelectkey = this.map.on('singleclick', evt => {
            if (!this.showMeasuringTool) {
              this.querySite(
                evt,
                this.ptv_layersObj[obj].layer,
                this.map,
                param[0].link_object.params.LAYERS
              )
            }
          })
        }
      }
    },
    removeAttributesWindowListener() {
      new unByKey(this.olSelectkey);
      this.olSelectkey = null;
    },
    querySite(evt, layers, map, geoserverName, cqlFilter = null) {
      const source = layers.getSource()
      if (!cqlFilter) {
        cqlFilter = source.getParams().CQL_FILTER
      }
      const viewResolution = map.getView().getResolution()
      const options = {
        INFO_FORMAT: 'application/json',
        LAYERS: geoserverName,
        CQL_FILTER: 'INCLUDE' + `${cqlFilter ? ` AND ${cqlFilter}` : ''}`,
        QUERY_LAYERS: geoserverName,
        VIEWPARAMS: null
      }
      let url =
        source.getFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          'EPSG:3857',
          options
        ) + '&FEATURE_COUNT=100&buffer=5&format_options=callback:getJsonFeature&authkey=' + sessionStorage.token

      if (sessionStorage.token) {
        axios
          .get(url, {})
          .then(response => {
            if (response.data.features.length > 0) {
              this.attribResponse = []
              this.features = []
              this.feature_index = 0
              this.queryWindowResponse = []
              this.queryWindowResponse = response

              this.populateQueryWindow(response, 'IMAGE', geoserverName)

              if (geoserverName == 'mmp:lidar_trails' && !this.showSnippingTool) {
                this.selectTrail(response.data)
                
                response.data.features.forEach(feature => {
                  const index = this.cart.findIndex(
                    item => item.pc_id === feature.properties.pc_id
                  );
                  if (index !== -1) {
                    this.cart.splice(index, 1);
                    return;
                  }
                  this.cart.push(feature.properties)
                })
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    async addHexagonSymbolizer(featureCoordinates) {
      // Create point vector layer (hexagon) of clicked feature
      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              type: 'geoMarker',
              geometry: new Point(
                featureCoordinates
              )
            })
          ]
        }),
        zIndex: 1000,
        style: new Style({
          image: new RegularShape({
            points: 6, // Number of points for the hexagon
            radius: 14, // Radius of the hexagon
            fill: new Fill({ color: 'rgba(6, 60, 109, 0.2)' }), // Fill color
            stroke: new Stroke({ color: '#00008B', width: 2 }), // Border color and width
          })
        })
      })

      this.map.addLayer(this.vectorLayer)
    },
    showNextAttribute(value) {
      this.feature_index = value
      this.populateQueryWindow(this.queryWindowResponse, 'IMAGE')
    },
    populateQueryWindow(response, layerType, geoserverName = null) {
      let clickedLayerName
      let data = response.data
      let site;
      if (layerType == 'IMAGE') {
        this.features = data.features
        // REFACTOR -- WEBGIS-2548 -- this is not a variable in MMP.vue. Added it.
        this.fullSite = this.features[this.feature_index]
        site = this.features[this.feature_index].properties
      }
      clickedLayerName = this.features[this.feature_index]['id']
      this.clickedLayerName = clickedLayerName
      if (clickedLayerName) {
        clickedLayerName = clickedLayerName.split('.')[0]
        clickedLayerName = clickedLayerName.substr(0, 1).toUpperCase() + clickedLayerName.substr(1, clickedLayerName.length)
        // this.showAttributes = true
      }
      this.attribResponse = []
      for (let key in site) {
        if (site.hasOwnProperty(key)) {
          this.attribResponse.push({
            value: site[key],
            name: key
          })
        }
      }
      
      // Get array of coordinates. Will be 2D array for linestrings.
      let geomCoordinates = this.fullSite.geometry.coordinates
      // Get length 2 array of coordinates and store them in featureCoordinates
      let featureCoordinates =
        geomCoordinates.length > 2
          ? geomCoordinates[Math.round(geomCoordinates.length / 2)]
          : geomCoordinates
      // Remove previous vectorLayer from the map
      this.map.removeLayer(this.vectorLayer)

      let coords = new fromLonLat(featureCoordinates, 'EPSG:4326')

      // Create vector layer of clicked feature
      this.addHexagonSymbolizer(coords)
    },
    handleDrag({ target, transform }) {
      target.style.transform = transform
    },
    maxOrMinAttributes(bool) {
      this.attributesPanelMinimized = bool
    },
    closeAttTable() {
      this.showAttributes = false
      this.attribResponse = null
      // Removes circle that appears on map when user inputs coordinates to zoom to
      this.map.removeLayer(this.vectorLayer)
      this.vectorLayer = null
    },
    async addPoint(feature) {
      this.map.removeLayer(this.vectorLayer);
      this.vectorLayer = null

      this.vectorLayer = new VectorLayer({
        source: new VectorSource({
          features: [feature]
        }),
        zIndex: 1000
      })

      this.map.addLayer(this.vectorLayer)
    },
    async putLayerOnTop(data) {
      this.drtLayersButtonsCtrl = this.putLayerOnTopHelper(
        this.drtLayersButtonsCtrl,
        data.payload.layerName
      )

      data.resolve();
    },
    putLayerOnTopHelper(arr, layerName) {
      for (let layerIndex in arr) {
        let layer = arr[layerIndex]
        if (layer.display_name == layerName || layer.name == layerName) {
          // Removes layer from array
          arr.splice(layerIndex, 1)
          // Adds layer back at the beginning of the array
          arr.unshift(layer)
          break
        }
      }
      return arr
    },
    
    async addPolygonToMap(attr) {
      this.disableTrailGroups = true

      const featureInput = attr.featureInput
      const isFileUpload = attr.isFileUpload
      if (featureInput) {
        const features = Array.isArray(featureInput)
          ? featureInput
          : [featureInput.getType && !featureInput.getId
            ? new Feature({ geometry: featureInput })
            : featureInput]

        const vectorSource = new VectorSource({ features })
        const vectorLayer = new VectorLayer({
          source: vectorSource,
          style: this.styleWKTGeometry(),
          zIndex: 1000
        })

        this.polygonVectorLayers.unshift(vectorLayer)
        this.map.addLayer(vectorLayer)
        
        if (isFileUpload) {
          this.zoomToFitFileUploadPolygons()
        } else {
          this.zoomToFitPolygons()
        }

        // this.polygonsSelected.push()

        // await this.addPolygonListener();
        await this.autoSelectUploadedPolygons(vectorLayer);
      }
    },
    async autoSelectUploadedPolygons(vectorLayer) {
      // if (!this.polygonSelectEvent) return;

      const features = vectorLayer.getSource().getFeatures();
      if (!features.length) return;

      // Clear previous selections
      this.polygonsSelected = [];
      // this.polygonSelectEvent.getFeatures().clear();

      // Push all uploaded polygons into the selection collection
      features.forEach((feature, index) => {
        const geomType = feature.getGeometry().getType();
        if (
          geomType === 'Polygon' ||
          geomType === 'MultiPolygon' ||
          geomType === 'LineString' ||
          geomType === 'MultiLineString'
        ) {

          this.polygonsSelected.push(feature);
          // this.polygonSelectEvent.getFeatures().push(feature);

          // feature.setStyle(new Style({
          //   fill: new Fill({ color: '#ff000033' }),
          //   stroke: new Stroke({ color: '#ff0000', width: 2 }),
          //   text: new Text({
          //     text: (index + 1).toString(),
          //     fill: new Fill({ color: '#ff0000' }),
          //     stroke: new Stroke({ color: '#ffffff', width: 2 }),
          //     font: 'bold 14px Arial',
          //     overflow: true
          //   })
          // }));
        }
      });
    },
    zoomToFitPolygons() {
      if (!this.polygonVectorLayers.length) return;

      const latestLayer = this.polygonVectorLayers[0];
      const source = latestLayer.getSource();
      const features = source.getFeatures();

      if (!features.length) return

      /* ======= 
      WEBGIS-3863  
        Get only the latest geometry drawn/uploaded to the vector layers object that must be LineString / MultiLineString / Polygon / MultiPolygon to calculate the zoom level bounds. 
      ======= */
      const latestFeature = [...features].reverse().find(f => {
        const type = f.getGeometry().getType()
        return ['LineString', 'MultiLineString', 'Polygon', 'MultiPolygon'].includes(type)
      })

      if (!latestFeature) return

      // Get extent of this feature
      const extent = latestFeature.getGeometry().getExtent();

      this.map.getView().fit(extent, {
        size: this.map.getSize(), // get the actual map size to calculate zoom level for extent bounds
        padding: [100, 100, 100, 100], // smaller padding for a tighter fit
        duration: 600,
      })
    },
    zoomToFitFileUploadPolygons() {
      if (!this.polygonVectorLayers.length) return
      let combinedExtent = null

      const layer = this.polygonVectorLayers[0]
      const source = layer.getSource()
      if (source.getFeatures().length > 0) {
        source.getFeatures().forEach(feature => {
          const featureExtent = feature.getGeometry().getExtent()
          if (!combinedExtent) {
            combinedExtent = [...featureExtent]
          } else {
            combinedExtent = [
              Math.min(combinedExtent[0], featureExtent[0]),
              Math.min(combinedExtent[1], featureExtent[1]),
              Math.max(combinedExtent[2], featureExtent[2]),
              Math.max(combinedExtent[3], featureExtent[3])
            ]
          }
        })
      }

      if (combinedExtent) {
        this.map.getView().fit(combinedExtent, {
          size: this.map.getSize(), // get the actual map size to calculate zoom level for extent bounds
          padding: [100, 100, 100, 100],
          duration: 1000
        });
      }
    },
    removePolygons() {
      this.polygonVectorLayers.forEach((polygon) => {
        this.map.removeLayer(polygon)
      })
      // this.map.removeLayer(this.polygonVectorLayer)
      this.polygonVectorLayers = []
      this.polygonsSelected = []
    },
    removePolygonListener() {
      this.map.removeInteraction(this.polygonSelectEvent)
      this.polygonSelectEvent = null
      this.polygonsSelected = [];
    },
    async addPolygonListener() {
      if (this.polygonSelectEvent || this.lidarFlag) {
        return;
      }
      this.polygonSelectEvent = new Select({
        condition: click,
        toggleCondition: click,  // Allows toggling selection on click
        multi: true,
        clearCondition: never,
        // Decide what geometries should be selectable.
        filter: (feature) => 
           feature.getGeometry().getType() === 'Polygon' 
        || feature.getGeometry().getType() === 'MultiPolygon' 
        || feature.getGeometry().getType() === 'LineString' 
        || feature.getGeometry().getType() === 'MultiLineString'
      });

      this.polygonSelectEvent.on('select', (e) => {
        // Apply red style to newly selected features
        e.selected.forEach(feature => {
          this.polygonsSelected.push(feature)
          feature.setStyle(new Style({
            fill: new Fill({ color: '#ff000033' }), // Red semi-transparent fill
            stroke: new Stroke({ color: '#ff0000', width: 2 }),  // Red stroke
            text: new Text({
              text: this.polygonsSelected.length.toString(),
              fill: new Fill({ color: '#ff0000' }),
              stroke: new Stroke({ color: '#ffffff', width: 2 }),
              font: 'bold 14px Arial',
              overflow: true, // ensures text is shown even if partially outside view
            })
          }));
        });

        // Reset style to yellow for deselected features
        e.deselected.forEach(feature => {
          const index = this.polygonsSelected.indexOf(feature);
          if (index > -1) {
            this.polygonsSelected.splice(index, 1);
          }
          feature.setStyle(new Style({
            fill: new Fill({ color: '#dde32933' }), // Yellow semi-transparent fill
            stroke: new Stroke({ color: '#8f9400', width: 2 })  // Yellow stroke
          }));
        });

        // Re-index and re-style all selected polygons with updated labels
        this.polygonsSelected.forEach((feature, index) => {
          feature.setStyle(new Style({
            fill: new Fill({ color: '#ff000033' }),
            stroke: new Stroke({ color: '#ff0000', width: 2 }),
            text: new Text({
              text: (index + 1).toString(),  // sequential numbering
              fill: new Fill({ color: '#ff0000' }),
              stroke: new Stroke({ color: '#ffffff', width: 2 }),
              font: 'bold 14px Arial',
              overflow: true
            })
          }));
        });
      });   

      this.map.addInteraction(this.polygonSelectEvent)
      this.polygonsSelected = []
    },
    clearPolygon(){
      this.removePolygons()
      this.removePolygonListener()
      // this.measurement = null
    },
    // WEBGIS-3793 - creating style as per the geometries inside wkt feature 
    styleWKTGeometry() {
       const style = feature => {        
        const geomType = feature.getGeometry().getType()        
        switch (geomType) {
          case 'LineString':
          case 'MultiLineString':
            return new Style({
              stroke: new Stroke({
                color: '#8f9400',
                width: 3
              })
            })
          case 'Polygon':
          case 'MultiPolygon':
            return new Style({
              fill: new Fill({ color: '#dde32933' }),
              stroke: new Stroke({ color: '#8f9400', width: 2 })
            })
          default:
            return new Style({
              stroke: new Stroke({ color: '#8f9400', width: 2 })
            })
        }
      }

      return style
    },
    acknowledgeTutorial(name) {
      if (sessionStorage.token) {
        let body = {
          name: name,
          value: true,
          user_id: this.user.id
        }
        axios.put(process.env.API_LOCATION + '/api/tutorial/acknowledge', body,
          {
            headers: {
              'x-auth-token': sessionStorage.token
            },
          }
        ).then(response => {
          const content = response.data
          if (content.errors) {
            console.log(content.errors)
          }
          this.getUser();
        })
          .catch(function (error) {
            console.log(error)
          })
      } else {
        console.log('No User Token')
      }
    },
    startTutorial() {
      this.driverObj.drive();
    },
    async triggerTRTTutorial() {
      if (!this.driverObj) {
        await this.generateTutorial();
      }
      this.startTutorial();
    },
    generateTutorial() {
      // this.$refs.ptvWidgets.startTutorial();
      this.driverObj = driver({
        showProgress: true,
        showButtons: ['next', 'previous', 'close'],
        steps: [
          { 
            element: '#Trail_Coverage', 
            popover: { title: 'LiDAR Trail Coverage', description: 'The Trail Coverage layer shows where on the map DMPNA has available LiDAR data. Zoom into zoom level 5+ to activate it.', side: "left", align: 'start' }
          },
          { 
            element: '#LiDAR_Trails', 
            popover: { 
              title: 'LiDAR Trails', 
              description: 'The LiDAR Trails layer becomes activated at zoom level 15+. Zoom into anywhere on the map to view all the available trails there.', 
              side: "bottom", 
              align: 'start',
              onNextClick: async () => {
                let lat = 42.226005
                let long = -83.685699
                this.map.getView().setCenter(fromLonLat([long, lat]));
                this.map.getView().setZoom(16);
                this.$nextTick(() => {
                  this.driverObj.moveNext()
                })
              } 
            }
          },
          { 
            element: '#trail_groups', 
            popover: { 
              title: 'LiDAR Groups', 
              description: `At zoom level 15+, this window becomes populated with any LiDAR trails within the current viewport. 
                            The trails are sorted by date acquired in the format YYMMDD. Clicking the carrot icon expands and collapses each group!`, 
              side: "bottom", 
              align: 'start',
              onNextClick: async () => {
                let obj = this.distinct_trails.find((IDobj) => IDobj.dateCode == '250614')

                obj.groupIsCollapsed = false

                this.$nextTick(() => {
                  this.driverObj.moveNext()
                })
              }  
            }
          },
          {
            element: '#trail_250614',
            popover: {
              title: 'Add Trails to Cart', 
              description: `Expanding the groups shows individual trails. 
                            Clicking on individual trails or the group tag adds trails to the cart. Clicking on trails on the map also adds them to your cart.`, 
              side: "bottom", 
              align: 'start',
              onNextClick: async () => {
                let btn = document.getElementById('pc-Record003,W_250614_121657_S0')
                if (!this.cart.length && btn) {
                  btn.click()
                }
                this.$nextTick(() => {
                  this.driverObj.moveNext()
                })
              }
            }
          },
          {
            element: '#cart',
            popover: {
              title: 'Trails Cart', 
              description: 'All trails added to your cart will appear here.', 
              side: "bottom", 
              align: 'start'
            }
          },
          {
            element: '#lidarStatsBtn',
            popover: {
              title: 'Generate Statistics', 
              description: 'Click this button to generate statistics on your cart selections.', 
              side: "bottom", 
              align: 'start'
            }
          },
          {
            element: '#clearTrailsBtn',
            popover: {
              title: 'Clear Cart', 
              description: 'Click this button to clear your cart!', 
              side: "bottom", 
              align: 'start',
              onNextClick: () => {
                // this.clearCart();
                this.$nextTick(() => {
                  this.driverObj.moveNext()
                })
              }
            }
          },
          { 
            element: '#polygonWidget', 
            popover: { 
              title: 'Draw Polygon', 
              description: `Clicking this widget allows you to draw a polygon around any area you want LiDAR data for. 
                            Once drawn, all trails in that polygon are added to your cart.`, 
              side: "left", 
              align: 'start'
            },
          },
        ],
        onDestroyStarted: () => {
          // this.$emit('acknowledgeTutorial', 'TRT')
          this.acknowledgeTutorial('TRT')
          this.clearCart();

          this.driverObj.destroy();
        }
      });
    },
    toggleLidarPanel(evt = null) {
      this.toggleLidarDownload()
      this.showLidarPanel = !this.showLidarPanel
    },
    toggleTrailsPanel(evt = null) {
      this.toggleTrailsDownload()
      this.showTrailsPanel = !this.showTrailsPanel
    },
    onYearFilterChanged(selectedYears) {
      this.filteredYears = selectedYears

      // Re-style already-selected trails (vector layer)
      this.selectedTrailsLayer?.changed()

      // Apply CQL filter to the WMS lidar_trails background layer
      const trailsLayerEntry = Object.values(this.ptv_layersObj || {}).find(entry => {
        const params = entry.layer?.getSource?.()?.getParams?.()
        return params?.LAYERS?.includes('lidar_trails')
      })

      if (trailsLayerEntry) {
        const source = trailsLayerEntry.layer.getSource()
        if (selectedYears.length === 0) {
          source.updateParams({ CQL_FILTER: '1=0' })
        } else {
          const totalYears = new Date().getFullYear() - 2014 + 1
          if (selectedYears.length === totalYears) {
            source.updateParams({ CQL_FILTER: undefined })
          } else {
            const cql = `year in (${selectedYears})`
            source.updateParams({ CQL_FILTER: cql })
          }
        }
      }
    },
    setLidarMinZoomAchieved(bool) {
      this.lidarMinZoomAchieved = bool
    },
    toggleLidarDownload() {
      // Lidar was off, turning it on
      if (!this.showLidarPanel) {
        this.getMapExtent()
        this.lidarDownload(this)
        // Else lidar is on, turning it off
      } else {
        // Hide any lidar on map, clear moveend listener, clear distinct_lidar arr
        this.clearLidar()
      }
    },
    toggleTrailsDownload() {
      // Lidar was off, turning it on
      if (!this.showTrailsPanel) {
        this.getMapExtent()
        this.trailDownload(this)
        // Else lidar is on, turning it off
      } else {
        // Hide any lidar on map, clear moveend listener, clear distinct_lidar arr
        this.distinct_trails = []
      }
    },
    clearLidar() {
      let lidarLayersToRemove = []
      // Get the lidar layers
      this.map.getLayers().forEach(layer => {
        let layerNameStr = layer.get('name')
          ? layer.get('name').toString()
          : null
        if (layerNameStr && layerNameStr.includes('lidar')) {
          lidarLayersToRemove.push(layer)
        }
      })
      // Remove the lidar layers
      lidarLayersToRemove.forEach(layer => {
        this.map.removeLayer(layer)
      })

      // Clear distinct lidar arr
      this.distinct_lidar = []
    },
    getMapExtent() {
      this.extentName = this.selectedExtent
        ? this.selectedExtent
        : JSON.parse(sessionStorage.Extent ?? 'null')
    },
    trailDownload: async self => {
      if (self.zoomEnded >= 15) {

        self.trailsLoading = true

        let extent = self.map.getView().calculateExtent(self.map.getSize())

        let userExtentBoxCoords = transformExtent(
          extent,
          'EPSG:3857',
          'EPSG:4326'
        )

        let apiUrl

        switch (self.extentName) {
          case 'North America':
            apiUrl = '/api/drt/ptv_lidar_trails'
            break
          default:
            self.trailsLoading = false
            return
        }

        if (!sessionStorage.token) {
          console.log('No User Token')
          self.trailsLoading = false
          return
        }

        try {
          const response = await axios.get(
            process.env.API_LOCATION + apiUrl,
            {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              params: {
                xmin: userExtentBoxCoords[0],
                ymin: userExtentBoxCoords[1],
                xmax: userExtentBoxCoords[2],
                ymax: userExtentBoxCoords[3]
              }
            }
          )

          const content = response.data

          if (content.errors) {
            console.log('API Call Error: ' + content.errors)
            self.trailsLoading = false
            return
          }

          // Preserve expanded groups
          let expanded = self.distinct_trails
            .filter(g => !g.groupIsCollapsed)
            .map(g => g.dateCode)

          // Clear after response arrives
          self.distinct_trails = []

          content.forEach(trail => {

            // Extract first 6-digit sequence from pc_id
            let match = trail.pc_id.match(/\d{6}/)
            let dateCode = match ? match[0] : null

            if (!dateCode) return

            let group = self.distinct_trails.find(g => g.dateCode === dateCode)

            if (!group) {
              group = {
                dateCode: dateCode,
                groupIsCollapsed: true,
                pointcloudIDArr: []
              }
              self.distinct_trails.push(group)
            }

            group.pointcloudIDArr.push({
              pc_id: trail.pc_id,
              id: trail.id
            })
          })

          // Sort newest first
          self.distinct_trails.sort((a, b) =>
            parseInt(b.dateCode) - parseInt(a.dateCode)
          )

          // Re-expand previously expanded groups
          self.distinct_trails.forEach(group => {
            if (expanded.includes(group.dateCode)) {
              group.groupIsCollapsed = false
            }
          })

          self.trailsLoading = false
        } catch (error) {
          console.log(error)
          self.trailsLoading = false
          this.removePolygons();
          this.clearCart()
        }

      } else {
        self.distinct_trails = []
        self.trailsLoading = false
      }
    },
    lidarDownload: async self => {
      // Only check for lidar if at appropriate zoom level
      if (self.zoomEnded >= 17) {
        // Turn on Lidar spinner since no data has loaded
        self.lidarIsLoading = true

        // Calculate users view extent
        let extent = self.map.getView().calculateExtent(self.map.getSize())
        // Transform extent from OSM format to lat/lon coords
        // EPSG:3857 - 'This is projected coordinate system used for rendering maps in Google Maps, OpenStreetMap, etc.' https://epsg.io/3857
        // EPSG:4326 - 'Horizontal component of 3D system. Used by the GPS satellite navigation system and for NATO military geodetic surveying.' https://epsg.io/4326
        let userExtentBoxCoords = new transformExtent(
          extent,
          'EPSG:3857',
          'EPSG:4326'
        )
        let apiUrl
        switch (self.extentName) {
          case 'Japan':
            apiUrl = '/api/drt/available_lidar_japan'
            break
          case 'North America':
            apiUrl = '/api/drt/available_lidar'
            break
          case 'Europe':
            apiUrl = '/api/drt/available_lidar_europe'
            break
          case 'Middle East':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Kuwait':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
          case 'Saudi Arabia':
            apiUrl = '/api/drt/available_lidar_middle_east'
            break
        }
        if (sessionStorage.token) {
          await axios
            .get(process.env.API_LOCATION + apiUrl, {
              headers: {
                'x-auth-token': sessionStorage.token
              },
              // Four corners of users view
              params: {
                xmin: userExtentBoxCoords[0],
                ymin: userExtentBoxCoords[1],
                xmax: userExtentBoxCoords[2],
                ymax: userExtentBoxCoords[3]
              }
            })
            .then(response => {
              const content = response.data
              // If duplicate entry found, throw error and prevent submission
              if (content.errors) {
                console.log('API Call Error: ' + content.errors)
              } else {
                // Grab any expanded groups
                let expanded = []
                self.distinct_lidar.forEach(lidar => {
                  if (!lidar.groupIsCollapsed) {
                    expanded.push(lidar.dateCode)
                  }
                })
                // Clearing distinct lidar after the new call has been returned
                // reduces user interface interruption
                self.distinct_lidar = []

                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        // autoLoad: self.ansiComponent ? true : false
                      })
                    }

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    // Check if date code in pointcloud ID is distinct to group
                    if (
                      !self.distinct_lidar.some(e => e.dateCode == dateCode)
                    ) {
                      self.distinct_lidar.push({
                        dateCode: dateCode,
                        groupIsCollapsed: true,
                        pointcloudIDArr: []
                        //autoLoad: self.ansiComponent ? true : false
                      })
                    }
                  }
                })

                // Now that we have distinct lidar dates extracted in this.distinct_lidar, we can build sub nav
                content.forEach(lidar => {
                  // Checking if pointcloud ID needs more processing to remove prefix
                  // If pointcloud ID starts with a number, it does not need more processing
                  if (!isNaN(lidar.pc_id.charAt(0))) {
                    let dateCode = parseInt(lidar.pc_id).toString()

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)

                    // Else pointcloud ID has leading char and underscore I.E. C_140610_151507_S1
                  } else {
                    // Split on underscore to isolate date code
                    let findDateCode = lidar.pc_id.split('_')
                    // Date code will be index one
                    let dateCode = findDateCode[1]

                    let index =
                      self.distinct_lidar[
                      self.distinct_lidar.findIndex(
                        x => x.dateCode == dateCode
                      )
                      ]

                    index.pointcloudIDArr.push(lidar.pc_id)
                  }
                })

                // Sort distinct_lidar array so newest lidar is in index 0 and displayed first in the lidar subnav buttons
                self.distinct_lidar.sort((a, b) => {
                  return parseInt(b.dateCode) - parseInt(a.dateCode)
                })

                // Re expand any previously expanded groups
                // For each lidar group, check if matches any item in expanded array we created
                self.distinct_lidar.forEach(lidar => {
                  expanded.forEach(expandedGroupDateCode => {
                    // If match between distinct lidar group and a group that was previously expanded, re expand group
                    if (expandedGroupDateCode == lidar.dateCode) {
                      lidar.groupIsCollapsed = false
                    }
                  })
                })
                // Turn off Lidar spinner now that data has loaded
                self.lidarIsLoading = false
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          console.log('No User Token')
        }
        // Else user needs to zoom in further to access lidar
      } else {
        // Clear any lidar groups, since nothing is available at users current zoom
        self.distinct_lidar = []
        self.clearLidar()
        self.lidarIsLoading = false
      }
    },
    showZoomLevel() {
      this.map.on('moveend', evt => {
        this.zoomLevel = this.map.getView().getZoom()
      })
    },
    async clearCart() {
      // Remove
      this.selectedTrails.forEach((trail) => {
        this.selectedTrailsLayer
          .getSource()
          .removeFeature(trail);
      })

      this.selectedTrails = []
      this.cart = []
      this.disableTrailGroups = false;
    },
    onPointcloudClick(pointcloudID) {
      this.highlightTrail(pointcloudID);
      this.addToCart(pointcloudID, true);
    },
    highlightTrail(pointcloudID) {
      let baseUrl = 'https://geoserver-aws.ushrauto.com/geoserver/wfs';

      const params = {
        SERVICE: 'WFS',
        VERSION: '1.1.0',
        REQUEST: 'GetFeature',
        TYPENAME: 'mmp:lidar_trails',
        SRSNAME: 'EPSG:4326',
        OUTPUTFORMAT: 'application/json',
        // CQL_FILTER: `id = '${pointcloudID.id}'`,
        CQL_FILTER: `id = '${pointcloudID.id}' AND pc_id LIKE '%${pointcloudID.pc_id}%'`,
        // maxFeatures: 1,
        AUTHKEY: sessionStorage.token
      };

      // Build query string
      const queryString = new URLSearchParams(params).toString();

      // Final URL
      const url = `${baseUrl}?${queryString}`;

      axios.get(url).then(response => {
        this.selectTrail(response.data)
      }).catch(function (error) {
        console.log(error)
        this.removePolygons();
        this.clearCart()
      })
    },
    selectTrail(data) {
      try {
        const format = new GeoJSON();
        const features = format.readFeatures(data, {
          featureProjection: this.map.getView().getProjection()
        });

        features.forEach(feature => {
          const pcId = feature.get('pc_id');

          const existingIndex = this.selectedTrails.findIndex(
            f => f.get('pc_id') === pcId
          );

          if (existingIndex !== -1) {
            // Remove
            const existingFeature = this.selectedTrails[existingIndex];

            this.selectedTrails.splice(existingIndex, 1);
            this.selectedTrailsLayer
              .getSource()
              .removeFeature(existingFeature);
          } else {
            // Add
            this.selectedTrails.push(feature);
            this.selectedTrailsLayer
              .getSource()
              .addFeature(feature);
          }
        });

        // Re-index all selected features
        this.selectedTrails.forEach((feature, i) => {
          feature.set('selectedIndex', i + 1);
        });

        this.selectedTrailsLayer.changed();
      } catch (error) {
        console.log(error)
        this.removePolygons()
        this.clearCart();
      }
    },
    async addToCart(pointcloudID, animation) {
      try {
        const index = this.cart.findIndex(
          item => item.pc_id === pointcloudID.pc_id
        );
        if (index !== -1) {
          this.cart.splice(index, 1);
          return;
        }

        this.cart.push(pointcloudID);

        await this.$nextTick(() => {
          const targetCartEl = document.getElementById(`cart-${pointcloudID.pc_id}`);
          targetCartEl.style.visibility = 'hidden';

          const sourceEl = document.getElementById(`pc-${pointcloudID.pc_id}`);
          const cartEl = document.querySelector('.cart .cart-items');

          if (animation) {
            const sourceRect = sourceEl.getBoundingClientRect();

            const clone = sourceEl.cloneNode(true);
            clone.id = 'clone-' + clone.id
            clone.classList.remove('w-100');
            clone.classList.add('fly-clone');

            clone.style.position = 'fixed';
            clone.style.backgroundColor='#063c6d'
            clone.style.color='#FFFFFF'
            clone.style.left = `${sourceRect.left}px`;
            clone.style.top = `${sourceRect.top}px`;
            clone.style.width = `${sourceRect.width}px`;
            clone.style.height = `${sourceRect.height}px`;
            clone.style.zIndex = 9999;

            // Explicit start state
            clone.style.transform = 'translate(0, 0) scale(1)';
            clone.style.opacity = '1';

            document.body.appendChild(clone);
            clone.getBoundingClientRect();

            // Animate to cart
            requestAnimationFrame(() => {
              const targetCartEl = document.getElementById(`cart-${pointcloudID.pc_id}`);
              let cartLeft, cartTop;
              
              if (targetCartEl) {
                const cartRect = targetCartEl.getBoundingClientRect();
                cartLeft = cartRect.left;
                cartTop = cartRect.top;
              } else {
                const cartRect = cartEl.getBoundingClientRect();
                cartLeft = cartRect.left;
                cartTop = cartRect.top;
              }

              clone.style.transform = `translate(${cartLeft - sourceRect.left}px, ${cartTop - sourceRect.top}px) scale(1)`;
            });

            clone.addEventListener('transitionend', (e) => {
              if (e.propertyName !== 'transform') return;
              const targetCartEl = document.getElementById(`cart-${pointcloudID.pc_id}`);

              // Reset styles so it behaves normally in cart
              clone.style.position = '';
              clone.style.left = '';
              clone.style.top = '';
              clone.style.transform = '';
              clone.style.opacity = '';
              clone.style.zIndex = '';

              if (targetCartEl && targetCartEl.parentNode) {
                targetCartEl.style.visibility = 'visible';
                clone.remove();
              } 
            });
          }
        });
      } catch (error) {
        console.log(error)
        this.clearCart();
        this.removePolygons();
      }
    },
    lidarSelectionByPcIds(pcIds) {
      const cqlFilter = `pc_id IN (${pcIds.map(id => `'${id}'`).join(',')})`
      const params = {
        SERVICE: 'WFS',
        VERSION: '1.1.0',
        REQUEST: 'GetFeature',
        TYPENAME: 'mmp:lidar_trails',
        SRSNAME: 'EPSG:4326',
        OUTPUTFORMAT: 'application/json',
        CQL_FILTER: cqlFilter,
        AUTHKEY: sessionStorage.token
      }

      const url = `https://geoserver-aws.ushrauto.com/geoserver/wfs?${new URLSearchParams(params).toString()}`

      this.kmzLoadingTotal = 1
      this.kmzLoadingDone = 0

      axios.get(url).then(response => {
        response.data.features.forEach(f => {
          const exists = this.cart.some(item => item.pc_id === f.properties.pc_id)
          if (!exists) {
            this.cart.push(f.properties)
            this.selectTrail(f)
          }
        })
        this.kmzLoadingDone = 1
      }).catch(error => {
        console.log(error)
        this.kmzLoadingDone = 1
        this.removePolygons()
        this.clearCart()
      })
    },
    lidarSelection(attr) {
      const features = Array.isArray(attr.geom)
        ? attr.geom
        : [attr.geom]

      this.kmzLoadingTotal = features.length
      this.kmzLoadingDone = 0

      features.forEach(feature => {
        const geom = feature.getGeometry()
        const extent = geom.getExtent()

        const min = toLonLat([extent[0], extent[1]])
        const max = toLonLat([extent[2], extent[3]])

        const bbox = {
          minX: min[0],
          minY: min[1],
          maxX: max[0],
          maxY: max[1]
        }

        const params = {
          SERVICE: 'WFS',
          VERSION: '1.1.0',
          REQUEST: 'GetFeature',
          TYPENAME: 'mmp:lidar_trails',
          SRSNAME: 'EPSG:4326',
          OUTPUTFORMAT: 'application/json',
          CQL_FILTER: `BBOX(wkb_geometry,${bbox.minX},${bbox.minY},${bbox.maxX},${bbox.maxY},'EPSG:4326')`,
          AUTHKEY: sessionStorage.token
        }

        const url = `https://geoserver-aws.ushrauto.com/geoserver/wfs?${new URLSearchParams(params).toString()}`

        axios.get(url).then(response => {
          response.data.features.forEach(f => {
            const exists = this.cart.some(
              item => item.pc_id === f.properties.pc_id
            )

            if (!exists) {
              this.cart.push(f.properties)
              this.selectTrail(f)
            }
          })
          this.kmzLoadingDone++
        }).catch(error => {
          console.log(error)
          this.kmzLoadingDone++
          this.removePolygons()
          this.clearCart()
        })
      })
    }
  },
  computed: { 
    ...mapGetters(['globalUserRole','globalAllowedUserModules','globalIsUserAllowed', 'globalVerifyCurrentUserRole'])
  },
  beforeDestroy() {
    this.driverObj.destroy();
  }
}
</script>
